


















import {Component, Vue} from 'vue-property-decorator';
import RenderModal from "@/components/Shared/RenderModal.vue";

@Component({
  components: {RenderModal}
})
export default class LoadingModal extends Vue {
  get showLoadingModal() {
    return this.$store.getters['loading/getLoadingStatus'];
  }
}
